interface V3IconChevronDownProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconChevronDown = ({ stroke = "#ABB0BA", strokeWidth = "1.5", ...rest }: V3IconChevronDownProps) => (
    <svg width="16" height="16" {...rest} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="m4 6 4 4 4-4" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
